import { useState, useEffect, useContext } from "react";
import styles from "./index.module.scss";
import { isMobileDevice } from "../../utils/getPlatformInfo";
import brandLogo from "../../assets/images/brandLogo.png";
import close from "../../assets/images/close.png";
import QR from "../../assets/images/qr_with_logo.png";
import playStore from "../../assets/images/playstore.png";
import appStore from "../../assets/images/appstore.png";
import closeIcon from "../../assets/images/close2.png";

import { useLocation } from "react-router-dom";
import { BUNDLE_ID, iosAppStoreId } from "../../AppConstants/Constants";
import { AnalyticsContext } from "../../contexts/Analytics/AnalyticsContextProvider";
import { GET_APP_EVENT } from "../../Clevertap/EventNames.ts";
import { TRENDS_OPEN_ROUTE } from "../../AppConstants/Routes.js";

function updateStatusINSessionStorage() {
  window.sessionStorage.setItem("app_redirect_modal", true);
}

const AppInstallPopUp = () => {
  const { addGAWithNoUser, addCleverTapAnalytics } =
    useContext(AnalyticsContext);
  const [showToast, setShowNetworkToast] = useState(false);
  const { pathname, search = "", hash = "" } = useLocation();

  const isTrendsOpenPath = pathname === TRENDS_OPEN_ROUTE;

  const params = new URLSearchParams(decodeURIComponent(search));
  const [link, setLink] = useState("");

  useEffect(() => {
    let returnURL = params.get("returnURL");
    if (returnURL) {
      returnURL = window.location.origin + returnURL;
    } else {
      returnURL = window.location.href;
    }
    setLink(returnURL);
  }, [search]);

  useEffect(() => {
    let status = window.sessionStorage.getItem("app_redirect_modal");
    if (!status || status != "true") {
      setShowNetworkToast(true);
    }
  }, []);

  const handleClose = () => {
    setShowNetworkToast(false);
    updateStatusINSessionStorage();
  };
    let finalLink = "https://link.docflix.com/byAN";

  const handleGetAppButton = async () => {
    // if (link) {
    //   finalLink = `https://link.docflix.com/?link=${encodeURIComponent(
    //     link
    //   )}&apn=${BUNDLE_ID}&ibi=${iosAppStoreId}&isi=${BUNDLE_ID}&efr=1`;
    // }
    let obj = {
      "Embeded Link": finalLink,
    };
    addGAWithNoUser(GET_APP_EVENT, obj);
    addCleverTapAnalytics(GET_APP_EVENT, obj);
    window.open(finalLink);
    updateStatusINSessionStorage();
  };

  return isMobileDevice && showToast && !isTrendsOpenPath ? (
    <div className={`${styles.container}`}>
      <div className="animate__animated animate__fadeInUp">
        <div className={styles.box}>
          <div className={styles.btnContainer}>
            <img
              src={close}
              className={styles.closeIcon}
              onClick={handleClose}
            />
            <p className={styles.title}>Docflix is better on the app</p>
            <p
              className={`${styles.btn} ${styles.getApp}`}
              onClick={handleGetAppButton}
              role="button"
            >
              GET APP
            </p>
          </div>
        </div>
      </div>
    </div>
  ) : !isMobileDevice && showToast && !isTrendsOpenPath ? (
    <div className={styles.desktopContainer}>
      <div className={styles.box}>
        <p className={styles.title}>Download our App</p>
        <img src={QR} alt="Docflix QR Downloader" className={styles.qr} />
        <div className={styles.storeIcons}>
          <a href={`https://play.google.com/store/apps/details?id=${BUNDLE_ID}`} target="_blank">
            <img
              src={playStore}
              className={styles.storeIcon}
              alt="Play Store"
            />
          </a>
          <a href={`https://apps.apple.com/app/id${iosAppStoreId}`} target="_blank">
            <img src={appStore} className={styles.storeIcon} alt="App Store" />
          </a>
        </div>
      </div>
      <div className={styles.closeIcon} onClick={handleClose}>
        <span className={styles.cross}>x</span>
      </div>
    </div>
  ) : null;
};

export default AppInstallPopUp;
